import { defaultBaseQuery, transformErrorResponse, transformSuccessResponse } from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const attendancePunchAPI = createApi({
    reducerPath: "attendancePunchAPI",
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        punchAttendance: builder.mutation({
            query: (body) => ({
                url: `/attendance`,
                method: "POST",
                body,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { usePunchAttendanceMutation } = attendancePunchAPI;
export default attendancePunchAPI;
